import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';

const action = 'Presign Consents';

export const AcceptTermsOfService = createAction(`[${action}] Accept Terms Of Service`);

export const FetchPrivacyPolicyConsent = createAction(`[${action}] Fetch Privacy Policy Consent`);

export const FetchUseOfAIConsent = createAction(`[${action}] Fetch Use Of AI Consent`);

export const FetchTermsAndConditionsConsent = createAction(
  `[${action}] Fetch Terms And Conditions Consent`
);

export const FetchEndorsementsConsent = createAction(`[${action}] Fetch Endorsements Consent`);

export const DeclineTermsOfService = createAction(`[${action}] Decline Terms Of Service`);

export const FetchAllTermsOfServiceConsents = createAction(
  `[${action}] Fetch All Terms Of Service Consents`
);

export const TermsOfServiceConsentInvalid = createAction(
  `[${action}] Terms of Service Consent Invalid`
);

export const TermsOfServiceSubmissionFailed = createAction(
  `[${action}] Terms Of Service Submission Failed`, props<{ response: HttpErrorResponse,  notificationText: string}>()
);
